import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { getMapLayers, setLayerWeight } from '../reducers/mapLayers';
import { openModal } from '../reducers/modal';

const PlanItem = ({ id }) => {
  const layers = useSelector(getMapLayers);
  const { name, weight, description } = layers.find((layer) => layer.id === id);
  const dispatch = useDispatch();

  const weightChange = (event) => dispatch(setLayerWeight(id, event.target.value));
  // const opacityChange = (event) => dispatch(setPlanOpacity(id, event.target.value));

  const marks = [
    { value: 0, label: 'Off' },
    { value: 1, label: 'Low' },
    { value: 2 },
    { value: 3, label: 'Medium' },
    { value: 4 },
    { value: 5, label: 'High' },
  ];

  const infoClick = () => dispatch(openModal({ data: { title: name, msg: description } }));

  const textStyle = {
    display: 'inline-block',
    width: 184,
    whiteSpace: 'normal',
    fontSize: 14,
    lineHeight: 1.3,
  };

  const infoStyle = {
    fontFamily: 'Material Icons',
    fontSize: 16,
    width: 20,
    height: 24,
    minWidth: 20,
    minHeight: 24,
    background: 'white',
    color: '#808080',
    boxShadow: 'none',
    '&:hover': {
      background: '#ececec',
      boxShadow: 'none',
    },
    cursor: 'pointer',
  };

  return (
    <ListItem>
      <Box sx={{ padding: 0, paddingLeft: 2, paddingRight: 2, width: 230 }}>
        <Typography sx={textStyle}>{name}</Typography>
        <Button id="info" sx={infoStyle} onClick={infoClick}>&#xe88e;</Button><br />
        <Box>
          <Slider min={0} max={5} step={1} value={weight} marks={marks} onChange={weightChange} sx={{ marginLeft: '10px', width: '184px' }} />
        </Box>
      </Box>
    </ListItem>
  );
};

export default PlanItem;
